import axios from 'axios'

export default {
    // optionally filter by uer
    async fetch({ query, page }) {
        return await axios.get(`auditlogs?query=${query}&page=${page}`)
    },

    async delete(id) {
        return await axios.delete(`auditlogs/${id}`)
    },
}
